/* app/ui/listing/filter */

define(
	'app/ui/listing/filter',[
		'jquery',
		'util/mediaqueries',
		'pubsub',
		'throttledebounce',
		'donetyping'
	],
	function($, MediaQueries) {

		var Module;

		var classes;

		var $listingContainer;
		var $filter;
		var $dropdowns;
		var $inputs;
		var $checkboxes;
		var $sort;
		var $filterToggle;

		return {
			init: function ($elm, classList) {
				Module = this;
				$listingContainer = $elm;
				classes = classList;

				Module._initElements();
				Module._initEvents();
				Module._initMediaQueries();
			},

			updateFilters: function (queryObj) {
				for (var i = 0; i < $dropdowns.length; i++) {
					var $thisDropdown = $dropdowns.eq(i);
					var dropdownName = $thisDropdown.attr('name');
					var resetDropdown = true;

					for (var j = 0; j < queryObj.filters.length; j++) {
						var thisFilter = queryObj.filters[j];

						if (thisFilter.filterName === dropdownName) {
							$thisDropdown.find('[value="' + thisFilter.filterOption + '"]').prop('selected', true);
							resetDropdown = false;
						}
					}

					if (resetDropdown) {
						$thisDropdown.find('option').first().prop('selected', true);
					}
				}
			},

			_initElements: function() {
				$filter = $listingContainer.find('.js-operator-filter, .js-filter');
				$dropdowns = $filter.find('.js-filter-dropdown');
				$inputs = $filter.find('.js-filter-input');
				$checkboxes = $filter.find('.js-filter-checkbox');
				$sort = $filter.find('.js-filter-sort');
				$filterToggle = $listingContainer.find('.js-filter-toggle');
			},

			_initEvents: function() {
				$listingContainer.on('click', '.js-filter-option', Module._removeFilterOption);
			},

			_initMediaQueries: function () {

				MediaQueries.register([
					{
						// Bind Small Filter Events
						queries: MediaQueries.queries['megamenu--small'],
						shouldDegrade: false,
						match: Module._initMobileEvents,
						unmatch: Module._unbindMobileEvents
					}, {
						// Bind Large Filter Events
						queries: MediaQueries.queries['megamenu--large'],
						shouldDegrade: true,
						match: Module._initDesktopEvents,
						unmatch: Module._unbindDesktopEvents
					}
				]);
			},

			_initMobileEvents: function () {
				$filterToggle.on('click', Module._toggleFilter);
				$listingContainer.on('click', '.js-filter-cancel', Module._toggleFilter);
				$listingContainer.on('click', '.js-filter-apply', Module._applyMobileFilter);
			},

			_unbindMobileEvents: function () {
				$filterToggle.off('click', Module._toggleFilter);
				$listingContainer.off('click', '.js-filter-cancel', Module._toggleFilter);
				$listingContainer.off('click', '.js-filter-apply', Module._applyMobileFilter);
				$filter.removeClass(classes.open);
			},

			_initDesktopEvents: function() {
				$filter.on('change', '.js-filter-dropdown, .js-filter-sort, .js-filter-checkbox', Module._applyFilter);
				$inputs.donetyping(function () {
					Module._applyFilter();
				});
			},

			_unbindDesktopEvents: function () {
				$filter.off('change', '.js-filter-dropdown, .js-filter-sort, .js-filter-checkbox', Module._applyFilter);
				$inputs.unbind('keyup keypress paste change');
			},

			_toggleFilter: function(event) {
				event.preventDefault();

				$.publish('/operator/listing/overlay');
				$.publish('/header/hide');
				$filter.toggleClass(classes.open);
			},

			_applyMobileFilter: function(event) {
				event.preventDefault();

				Module._applyFilter();
				$filter.toggleClass(classes.open);
			},

			_applyFilter: function() {
				$.publish('/operator/listing/overlay');
				$.publish('/story/listing/overlay');
				var queryObj = Module._getQueryProperties();

				$.publish('/operator/listing/update', queryObj);
				$.publish('/story/listing/update', queryObj);
			},

			_removeFilterOption: function(event) {
				event.preventDefault();
				var $option = $(this);
				var filterName = $option.data('filter-name');

				if (filterName !== '') {
					var $filter = $('[name="' + filterName + '"]');

					if ($filter.length) {
						var type = $filter.data('filter-type');
						if (type === 'dropdown') {
							$filter.find('option').eq(0).prop('selected', true);
						}
						else if (type === 'input'){
							$filter.val(0);
						}
						else {
							//type = checkbox
							$filter.prop('checked', false);
						}
						Module._applyFilter();
					}

				}
			},

			_getQueryProperties: function() {
				var queryString = '';
				var queryObj = {};
				var dropdownFilters = [];
				var inputFilters = [];
				var checkboxFilters = [];
				// dropdown
				for (var i = 0; i < $dropdowns.length; i++) {
					var $thisDropdown = $dropdowns.eq(i);
					var name = $thisDropdown.attr('name');
					var value = $thisDropdown.val();

					if (value !== '') {
						queryString += '&' + encodeURIComponent(name) + '=' + encodeURIComponent(value);

						dropdownFilters.push({
							filterName: name,
							filterOption: value,
							filterType: 'select'
						});
					}
				}
				//input
				for (var i = 0; i < $inputs.length; i++) {
					var $thisInput = $inputs.eq(i);
					var name = $thisInput.attr('name');
					var value = $thisInput.val();

					if (value !== '') {
						queryString += '&' + encodeURIComponent(name) + '=' + encodeURIComponent(value);

						if (value > 0) {
							inputFilters.push({
								filterName: name,
								filterOption: value
							});
						}

					}
				}

				for (var i = 0; i < $checkboxes.length; i++) {
					var $thisCheckbox = $checkboxes.eq(i);
					var name = $thisCheckbox.attr('name');
					var value = $thisCheckbox.prop('checked');

					if (value !== '') {
						queryString += '&' + encodeURIComponent(name) + '=' + encodeURIComponent(value);

						if (value) {
							checkboxFilters.push({
								filterName: name,
								filterOption: 'With Accommodation'
							});
						}
						
					}
				}

				if ($sort.val()) {
					queryString += '&Sort=' + encodeURIComponent($sort.val());
				}

				queryObj.queryString = queryString.substring(1);
				queryObj.dropdownFilters = dropdownFilters;
				queryObj.inputFilters = inputFilters;
				queryObj.checkboxFilters = checkboxFilters;

				return queryObj;
			}
		};
	}
);
